import { DeviceThing } from '../../types/DeviceThing.types'

const DEFAULT_DEVICE_THING: Omit<DeviceThing, 'thingArn' | 'thingName' | 'thingTypeName' | 'version'> = {
    instance: null,
    lastUpdate: 0,
    lastUpdateString: '',
    shadowDocuments: {},
    shadowErrors: {},
    fieldReadErrors: {},
    system: {
        TZ_DATABASE_NAME: 'Europe/Warsaw',
        VMSN: 'asdsystems',
        NTP_SERVERS: '',
    },
    datasyncd: {
        DB_SQLITE_PATH: '/data/db/db.sqlite',
        RESTAPI_HOST: '',
        RESTAPI_USER: '',
        RESTAPI_PASSWORD: '',
        RESTAPI_OAUTHFILE: '',
        RESTAPI_PROTOCOL: 'https',
        RESTAPI_VERSION: 1,
        RESTAPI_FETCH_LIMIT: 100,
        SYNCD_STORAGEDIR: '/data/vend_images',
        SYNCD_INTERVAL_SEC: 1,
        SYNCD_MONTHSBACK: 1,
        NO_COMMIT: false,
    },
    connman: {
        DeviceName: '',
        Domain: '',
        IPv4_address: '',
        IPv4_gateway: '',
        IPv4_mask: '',
        IPv6_address: '',
        IPv6_gateway: '',
        IPv6_mask: '',
        MAC: '',
        Nameservers: '',
        SearchDomains: '',
        Timeservers: '',
        Type: 'ethernet',
    },
    gsm: {
        GSM_ENABLED: true,
        ACCN: '*99***1#',
        APN: '',
        PIN: '9999',
    },
    vend: {
        LANGUAGE: 'EN',

        RESTAPI_ONLY_ASSIGNED_USERS: false,

        TRANSLATION_FILE: 'translations.json',
        TRANSLATION_ENFORCE_UPPER_CASE: false,

        UI_SLIDES_PATH: '/data/vend_slides',
        UI_IMAGES_PATH: '',
        UI_SWITCH_USER_LANGUAGE: false,
        UI_PROFILING_EVENTLOOP_LAG: 1000,
        UI_IDLE_SCR_TYPE: 'CLOCK',
        UI_CLOCK_12H_FORMAT: false,
        UI_IDLE_SCR_SLIDE_PERIOD: 3,
        UI_HIDE_INACTIVE_MENU_ITEMS: false,
        UI_SHOW_ZERO_PROD: false,
        UI_PRODUCT_FILTER_LEVEL: 'ACCESSIBLE_AND_UNDER_LIMIT',
        UI_US_DEF_VIEW: 'PRODUCT_CATALOG',
        UI_SHOW_PROD_CARD: false,
        UI_SHOW_ALL_COST_CENTERS: false,
        UI_FORCE_PARTIAL_COLLECTION: false,
        UI_FORCE_PARTIAL_RETURN: false,
        UI_FORCE_UNLIMITED_ACCESS_PROFILE: false,
        UI_PRODCATALOG_COLNUM: 2,
        UI_PRODCATALOG_ROWNUM: 5,
        UI_SHOW_INFO_AFTER_LOGIN: false,
        UI_DO_NOT_USE_DEFINED_MULTIPACKS: false,
        UI_SHORT_INACTIVITY_TIMEOUT: 60,
        UI_LONG_INACTIVITY_TIMEOUT: 120,
        UI_SHOW_ONLY_ASSIGNED_PRODUCTS_WHILE_LOADING: false,
        UI_SCREEN_WIDTH: 'AUTO',
        UI_SCREEN_HEIGHT: 'AUTO',
        UI_SCREEN_ROTATE: 'AUTO',
        UI_ENABLE_USER_AUTH_WITHOUT_PIN: false,
        UI_AUTH_USER_INPUT_TEXT_HIDDEN: false,
        UI_CAN_RETURN_ONLY_RENTABLE: false,
        UI_CAN_RETURN_ONLY_SERVICE_REQUIRED: false,
        UI_SKIP_SELECTION_FOR_SOLE_LABEL: false,
        UI_SKIP_SELECTION_FOR_SOLE_ITEM: false,
        UI_SHOW_USER_NAMES_ON_USERS_LIST: false,
        UI_DISTRIBUTION_WITH_BASKET: false,
        UI_BASKET_SIZE: 1,
        VM_DISTRIBUTION_REQUEST_VALID_DAYS: 7,
        UI_FILTER_LOCAL_DISTRIBUTION_REQUESTS: false,
        UI_HIDE_LOADING_THROUGH_FLAPS: false,
        UI_HIDE_LOADING_GROUP_OF_PRODUCTS: false,
        UI_HIDE_LOADING_WITH_CELL_SCANNER: false,
        UI_SHOW_LAST_DISTRIBUTIONS_OF_PRODUCT: false,
        UI_USER_PRODUCT_LIMIT_WITHOUT_RETURNS: false,
        UI_USER_AUTH_AT_DR_REALIZATION: false,
        UI_SHOW_ONLY_ASSIGNED_PRODUCT_ITEMS_WHILE_LOADING: false,
        UI_PATTERN_FILTER_DELAY: 2000,
        UI_SHOW_AVAILABLE_QUANTITY_IN_PRODUCT_CATALOG_WHILE_DISTRIBUTION: false,
        UI_SHOW_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION: false,
        UI_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION_TIMEOUT: 5,
        UI_SHOW_TREE_STRUCTURE_ON_DISTRIBUTION: true,
        UI_SHOW_ONLY_ASSIGNED_TO_DP_ON_DISTRIBUTION: false,
        UI_SHOW_TREE_STRUCTURE_ON_LOADING: false,
        UI_SHOW_ONLY_ASSIGNED_TO_USER_ON_LOADING: false,
        UI_SHOW_ZERO_PROD_ON_LOADING: true,
        UI_SWITCHING_FILTERS_ON_DISTRIBUTION: true,
        UI_SWITCHING_FILTERS_ON_LOADING: true,
        UI_HIDE_PRODUCT_CATALOG_CONFIG_WIDGET: false,
        UI_TRANSACTIONS_LIST_COLNUM: 1,
        UI_TRANSACTIONS_LIST_ROWNUM: 6,
        UI_USERS_LIST_COLNUM: 1,
        UI_USERS_LIST_ROWNUM: 5,
        UI_ASK_FOR_COST_CENTERS_ON_RETURN: false,

        VM_APPLICATION_VARIANT: 'BASIC',
        VM_REQUIRE_ZERO_CONSUMPTION_FOR_DISTRIBUTION: false,
        VM_US_INACT_TOUT: 15,
        VM_US_CELL_OPENED_TOUT: 30,
        VM_SET_CELL_SCHEMA_WHILE_LOADING: false,
        VM_PREVENT_LOADING_CELLS_WITH_SCHEMA: false,
        VM_CELLS_LABELING: 'NO',
        VM_NO_CAN_IFACE: false,
        VM_L40_LOCK_ON_ILLEGAL_OPEN_DISABLED: false,
        VM_LOG_NEW_TRANSACTION: false,
        VM_CELLS_REPLENISHMENT: false,
        VM_DISTRIBUTION_REQUEST_ENABLED: false,
        VM_ALLOW_RETURNS_TO_CELLS_WITH_SCHEMA_WITH_DIFFERENT_SIZE: false,
        VM_PRODUCT_ITEMS_ENABLED: false,
        VM_DETACH_PRODUCT_ITEM_AFTER_DISTRIBUTION: false,
        VM_PRODUCT_ITEMS_SINGLE_USE: false,
        VM_ALLOW_RETURNS_TO_LARGER_CELLS: false,
        VM_CELLS_CLOSED_PRE_CHECK: false,
        VM_INVENTORY_TRANSFER_ENABLED: false,
        VM_NEW_ENTITY_JOURNAL: true,
        VM_SCAN_CELL_MARGIN: 1,
        VM_SCAN_CELL_PERCENTAGE_COVERAGE: 40,
        VM_CARD_READERS: '',
        VM_FILTER_READERS: '',
        VM_FLEX_EJECTION_TIMEOUT: 10,
        VM_REQUIRE_PRODUCT_ITEM_SCAN: false,
        VM_ENABLE_OWN_DR_MANAGEMENT: false,
        VM_STOCKTAKING_WITH_CELL_SCANNER: false,
        VM_RETURNS_ENABLED: true,
        VM_COST_CENTERS_CREATION_ALLOWED: false,
        VM_DISTRIBUTION_LABEL_BLOCKLIST: '',
        VM_RETURN_LABEL_BLOCKLIST: '',
        VM_DISTRIBUTION_WITH_COST_CENTERS_SETS: false,
        VM_DR_AUTO_ACCEPT_ENABLED: false,
        VM_DR_AUTO_ACCEPT_INTERVAL: 300,
        VM_SHOW_RETURN_NOTIFICATION: true,
        VM_DISTRIBUTION_CELL_SELECT_STRATEGY: 'CLOSEST_FIRST',
        VM_SELFSERVICE_TAG_ASSIGNMENT: false,

        UI_SHOW_FPS_COUNTER: false,
        UI_SHOW_DS_CACHE_UPDATE_PENDING: false,

        VM_DB_ACCESS_TOUT_SEC: 15,
        VM_DB_ACCESS_HIDE_DELAY_MS: 0,
        VM_CAN_WAIT_FLAP_CLOSE_MS: 1000,
    },
}

export const createEmptyDeviceThing = ():
    Omit<DeviceThing, 'thingArn' | 'thingName' | 'thingTypeName' | 'version'> => {
    return structuredClone(DEFAULT_DEVICE_THING)
    //return JSON.parse(JSON.stringify(DEFAULT_DEVICE_THING))
}